const fileIcons: Record<string, string> = {};

/**
 * Returns a record of available file icon names mapped to their URLs.
 * @returns {Record<string, string>} The icons record
 */
export function getFileIcons(): Record<string, string> {
  if (Object.keys(fileIcons).length === 0) {
    const allIcons = import.meta.glob<string>(
      [
        '../../../assets/Icons/File Type/Blue/*.svg',
        '../../../assets/Icons/Social Media Library/*.svg',
      ],
      {
        eager: true,
        import: 'default',
      }
    );

    Object.entries(allIcons).forEach(([path, url]) => {
      const filename = path.split('/').pop()?.replace('.svg', '') ?? '';
      const cleanedName = filename.replace(/^Blue_/, '');
      fileIcons[cleanedName] = url;
    });
  }

  return fileIcons;
}
